import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import { Popover, PopoverBody } from 'reactstrap';
// [BB-1711]: disabling Popover for disabled button for now, since it's causing intermittent issues

export default class Button extends React.Component {
  static propTypes = {
    backgroundColor: PropTypes.string,
    border: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    icon: PropTypes.string,
    isSubmit: PropTypes.bool,
    onClick: PropTypes.func,
    size: PropTypes.oneOf(['sm', 'lg', 'lg-wide']),
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    transitional: PropTypes.bool,
    type: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'google', 'facebook', 'none', 'blank']),
    iconClassName: PropTypes.string,
    href: PropTypes.string,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    iconLeftAligned: PropTypes.bool,
    popOverDisabledText: PropTypes.string,
  };

  static defaultProps = {
    border: null,
    backgroundColor: null,
    className: '',
    disabled: false,
    fullWidth: false,
    isSubmit: false,
    onClick: () => {},
    onMouseEnter: () => {},
    onMouseLeave: () => {},
    type: 'primary',
    text: '',
    transitional: false,
    iconLeftAligned: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false);
  }

  componentWillUnmount() {
    clearTimeout(this.mouseLeaveTimeout);
    document.removeEventListener('mousedown', this.handleClick, false);
  }

  handleClick = (e) => {
    if (this.node && this.node.contains(e.target)) return;
    this.handleClickOutside();
  }

  handleClickOutside = () => {
    if (this.node) {
      this.setState({ isHovered: false });
    }
  }

  onClick = e => {
    this.props.onClick(e);
    if (this.props.href) {
      window.location.href = this.props.href;
    }
  };

  renderDisabledButtonWithPopOver() {
    // const popOverClassName = classNames({
    //   'default-popover': true,
    //   'default-popover--hidden': !this.state.isHovered,
    // });
    return (
      <span
        ref={node => this.node = node}
        onMouseEnter={() => {
          clearTimeout(this.mouseLeaveTimeout);
          this.setState({ isHovered: true });
        }}
        onMouseLeave={() => {
          this.mouseLeaveTimeout = setTimeout(() => {
            this.setState({ isHovered: false });
          }, 2000);
        }}
      >
        {this.renderButton()}
        {/* <Popover
          className={popOverClassName}
          isOpen={true}
          placement="top"
          target={() => this.button}
        >
          <PopoverBody>{this.props.popOverDisabledText}</PopoverBody>
        </Popover> */}
      </span>
    );
  }

  renderButton() {
    const {
      border,
      backgroundColor,
      className,
      disabled,
      fullWidth,
      icon,
      id,
      iconLeftAligned,
      isSubmit,
      iconClassName,
      size,
      text,
      children,
      transitional,
      type,
      onMouseEnter,
      onMouseLeave,
    } = this.props;

    const classes = classNames({
      'btn--full-width': fullWidth,
      'btn--transitional': transitional,
      btn: true,
      [`btn-${type}`]: !!type,
      [`btn-${size}`]: !!size,
      [className]: className,
    });

    const iconClasses = classNames({
      icon: true,
      [`icon-${icon}`]: true,
      [iconClassName]: !!iconClassName,
    });

    const styles = {
      border,
      backgroundColor,
    };

    const buttonText = text || children;

    const extraProps = {};
    if (id) {
      extraProps.id = id;
    }

    return (
      <button
        className={classes}
        disabled={disabled}
        style={styles}
        type={isSubmit ? 'submit' : 'button'}
        onClick={this.onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        {...extraProps}
        ref={node => (this.button = node)}
      >
        {icon && iconLeftAligned && <span className={iconClasses} />}
        {icon && iconLeftAligned && ' '}
        {buttonText}
        {transitional && <span className="icon icon-forwards-arrow" />}
        {icon && !iconLeftAligned && ' '}
        {icon && !iconLeftAligned && <span className={iconClasses} />}
      </button>
    );
  }

  render() {
    const { disabled, popOverDisabledText } = this.props;
    if (disabled && popOverDisabledText) {
      return this.renderDisabledButtonWithPopOver();
    }
    return this.renderButton();
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/button.js